import { getAnalytics, isSupported } from 'firebase/analytics'
import type { Analytics } from 'firebase/analytics'
import { getApp, initializeApp } from 'firebase/app'
import type { FirebaseApp } from 'firebase/app'

const ANALYTICS_APP_NAME = 'oura-tools-analytics'

const getOrInitApp = (): FirebaseApp => {
  try {
    return getApp(ANALYTICS_APP_NAME)
  } catch {
    return initializeApp(
      {
        // _ANALYTICS is pinned to web-oura-tools; VITE_FIREBASE_APP_ID resolves to the host app. See vite.config.apps.ts.
        appId: import.meta.env.VITE_FIREBASE_APP_ID_ANALYTICS,
        apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
        projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
        measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
      },
      ANALYTICS_APP_NAME,
    )
  }
}

export const analyticsReady: Promise<Analytics | null> = isSupported()
  .then((ok) => {
    if (ok && import.meta.env.VITE_FIREBASE_APP_ID_ANALYTICS && import.meta.env.VITE_FIREBASE_MEASUREMENT_ID) {
      return getAnalytics(getOrInitApp())
    } else {
      console.debug('Oura Tools analytics disabled (unsupported or missing config)')
      return null
    }
  })
  .catch((error) => {
    console.warn('Oura Tools analytics initialization failed', error)
    return null
  })
